import { logger } from "@/utils/logger";
import {
  deleteFilter,
  getSavedFilters,
  isFilterDAAQMatching,
  saveFilter,
 updateFilter} from "@/store/services/filter/filterService";
import {RootState, filter, filterState, SearchTask} from "@/types";
import Notify from 'quasar/src/plugins/Notify.js';;
import { Module } from "vuex";
import store from "@/store";
import i18n from "@/i18n";

const filterModule: Module<filterState, RootState> = {
    namespaced: true,
    state: {
        listOfFilters: [],
        ShowFilter: false,
        showEditMode: false,
        isUpdateButton: false,
        selectedFilter: undefined,
        isLoading: false,
        manuallyFilledSearchFields: '',
    },
    getters: {
        
        getInitFilterState() {
            return {
                listOfFilters: [],
                ShowFilter: false,
                showEditMode: false,
                isUpdateButton: false,
                selectedFilter: undefined,
                isLoading: false
            }
        },
        getFilterInit(): filter {
            return {
                description: '',
                hasPublicAccess: false,
                numOrder: 1,
                screenId: '',
                count: 0,
                color: '',
                businessData: {},
                objectType: "odm.configuration.filterstore",
                systemUid: "odm-configuration"
            }
        },
        listOfFilters(state) {
            return state.listOfFilters;
        },
        showFilter(state) {
            return state.ShowFilter;
        },
        getSelectedFilter(state) {
            return state.selectedFilter;
        },
        getIsUpdateButton(state) {
            return state.isUpdateButton;
        },
        getIsLoading(state){
            return state.isLoading;
        },
        getManuallyFilledSearchFields(state){
            return state.manuallyFilledSearchFields;
        }
    },
    actions: {
        setInitFiltersSate({ commit }) {
            const initFilter = {
                listOfFilters: [],
                ShowFilter: false,
                showEditMode: false,
                isUpdateButton: false,
                selectedFilter: undefined,
                isLoading: false,
                manuallyFilledSearchFields: ''
            }
            commit('setInitFiltersSate', initFilter)
        },
        showFilters({commit}) {
            commit('setShowListOfFilter', true)
        },
        disappearFilters({commit}) {
            commit('setShowListOfFilter', false)
        },
        showFilter({commit}) {
            commit('setShowFilter', true)
        },
        disappearFilter({commit}) {
            commit('setShowFilter', false)
        },
        setSelectedFilter({commit}, payload) {
            commit('setSelectedFilter', payload)
        },
        editSelectedFilter({commit}, payload) {
            commit('editSelectedFilter', payload)
        },
        async addFilter({dispatch}, payload) {
            if (!payload.resourceUid) {
                await saveFilter(payload)
                    .catch((err) => {
                        logger.error(err);
                        Notify.create({
                            timeout: 10000,
                            actions: [{ icon: 'close', color: 'white' }],
                            message: err.message || err.error || err,
                            color: "negative",
                        });
                    });
            } else{
                await updateFilter(payload)
                    .catch((err) => {
                        const message = err.message;
                        Notify.create({
                            timeout: 10000,
                            actions: [{ icon: 'close', color: 'white' }],
                            message,
                            color: "negative",
                    });
                });

            }
            await dispatch("getSavedFilters", { queryId: payload.screenId });       
        },
        async getSavedFilters({commit}, payload) {
            commit("setIsLoading", true);
            commit("setListOfFilters", []);
            const {queryId} = payload;
            await getSavedFilters(queryId)
                .then((response) => {
                    const config = store.getters["authModule/getDefaultDAAQConfig"];
                    if(config && Object.keys(config).length > 0){
                        const {defaultCreateDAAQ, readDAAQ} = config
                        const filteredList = [...response.filter((filter: any) => filter.hasPublicAccess || isFilterDAAQMatching(filter.daaq, {defaultCreateDAAQ, readDAAQ}))]
                        commit("setListOfFilters", filteredList);
                    }
                })
                .catch((err) => {
                    logger.error('error from filterModule',err);
                    Notify.create({
                        timeout: 10000,
                        actions: [{ icon: 'close', color: 'white' }],
                        message: err.message,
                        color: "negative",
                    });
                });
            commit("setIsLoading", false);
        },
    async deleteSelectedFilter({ dispatch }, payload) {
      await deleteFilter(payload)
        .then(() => {
          dispatch("getSavedFilters", { queryId: payload.screenId });
          store.dispatch("hideConfirmationDeleteDialog");
          Notify.create({
            timeout: 10000,
            actions: [{ icon: 'close', color: 'white' }],
            message: i18n.global.t("main.dialog.validation.success"),
            color: "positive",
          });
        })
        .catch((err) => {
          Notify.create({
            timeout: 10000,
            actions: [{ icon: 'close', color: 'white' }],
            message: err.message || err.error || err,
            color: "negative",
          });
        });
     },
        setManuallyFilledSearchFields({commit}, payload) {
            commit('setManuallyFilledSearchFields', payload)
        },
        cleanState({commit}) {
            commit('setInitial')
        }
    },
    mutations: {
        setInitFiltersSate(state, payload) {
            state.listOfFilters = payload.listOfFilters;
            state.ShowFilter = payload.ShowFilter;
            state.showEditMode = payload.showEditMode;
            state.isUpdateButton = payload.isUpdateButton;
            state.selectedFilter = payload.selectedFilter;
            state.isLoading = payload.isLoading;
        },
        setShowFilter(state, payload) {
            state.ShowFilter = payload
        },
        setListOfFilters(state, payload) {
            state.listOfFilters = payload
        },
        setSelectedFilter(state, payload) {
            state.selectedFilter = payload;
            state.showEditMode = false;
        },
        editSelectedFilter(state, payload) {
            state.selectedFilter = payload;
            state.showEditMode = true;
        },
        setIsUpdateButton(state , payload) {
            state.isUpdateButton = payload;
        },
        setUpdatedFilter(state , payload) {
            state.selectedFilter = payload;
        },
        setIsLoading(state, payload){
            state.isLoading = payload ?? false;
        },
        setManuallyFilledSearchFields(state, payload){
            state.manuallyFilledSearchFields = payload;
        },
        setInitial(state){
            state.manuallyFilledSearchFields = '';
        }
    }
}
export default filterModule;
